<template>
    <!-- 违章处理方式 -->
    <dialogWrap
      v-model="dvWayVisible"
      title="违章处理方式"
      width="560px"
    >
        <el-form
          :model="dvWayForm"
          ref="way_form"
          :rules="dvWayRules"
        >
          <el-form-item label="处理方式" prop="dealViolationWay">
            <el-select v-model="dvWayForm.dealViolationWay">
              <el-option
                v-for="item in dealViolationWayList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dvWayVisible = false">取 消</el-button>
            <el-button :loading="dvWayLoading" type="primary" @click="handleConfirm">
              确定
            </el-button>
        </span>
    </dialogWrap>
</template>

<script>
import { updateDealViolationWay } from '@/api/domain/carsService'
import selectOption from '@/store/dict/selectOptionDict'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      dvWayLoading: false,
      dvWayForm: {
        dealViolationWay: '',
        violationId: '',
      },
      dvWayRules: {
        dealViolationWay: [
          { required: true, message: '请选择处理方式', trigger: 'change' },
        ],
      },
    }
  },
  methods: {
    handleConfirm() {
      this.$refs.way_form.validate(async (valid) => {
        if (valid) {
          this.dvWayLoading = true
          try {
            const { code } = await updateDealViolationWay({
              ...this.dvWayForm,
            })
            this.dvWayLoading = false
            if (code === 1) {
              this.dvWayVisible = false
              this.dvWayForm.dealViolationWay = ''
              this.$emit('dvWayUpdated')
            }
          } catch (error) {
            this.dvWayLoading = false
          }
        }
      })
    },
  },
  computed: {
    dealViolationWayList() {
      return this.dictParseList(selectOption.dealViolationWayList)
    },
    dvWayVisible: {
      set(val) {
        if (!val) this.$emit('dvWayChange', val)
      },
      get() {
        return this.visible
      },
    },
  },
  watch: {
    id: {
      handler(val) {
        this.dvWayForm.violationId = val
      },
    },
  },
}
</script>
